'use strict';

const SoaCollection = require('bunsen/collections/SoaCollection');
const endpoints = require('dibs-endpoints');

const UserSocialNetwork = require('../../models/identity/UserSocialNetwork');
const {STATUS_CONNECTED, STATUS_DELETED} = UserSocialNetwork;

const UserSocialNetworks = SoaCollection.extend({
    model: UserSocialNetwork,

    getUserId() {
        return this.parents && this.parents[0].id;
    },

    url() {
        const userId = this.getUserId();
        return endpoints.userSocialNetworks(userId);
    },

    _save(socialNetworkModel, data = null, options = {}) {
        const {remove} = options;

        return new Promise((resolve, reject) => {
            socialNetworkModel.save(data, {
                success(model) {
                    resolve(model.toJSON());
                },
                error(model, response) {
                    if (remove) {
                        model.collection.remove(model);
                    }
                    reject(`${response.statusText}: ${response.responseJSON.message}`);
                }
            });
        });
    },

    getConnected(name) {
        const connected = this.find(model => {
            const sameName = model.get('socialNetwork.name') === name;
            const isConnected = model.get('status') === STATUS_CONNECTED;
            return sameName && isConnected;
        });

        return connected;
    },

    addNetwork(payload) {
        const {socialNetwork, userPreferences} = payload;
        const socialNetworkModel = this.add({socialNetwork, userPreferences}).last();

        return this._save(socialNetworkModel, null, {remove: true});
    },

    updateNetwork(payload = {}) {
        const {name, userPreferences} = payload;
        const socialNetworkModel = this.getConnected(name);

        if (socialNetworkModel) {
            return this._save(socialNetworkModel, {userPreferences});
        }

        return Promise.reject();
    },

    removeNetwork(name) {
        const socialNetworkModel = this.getConnected(name);

        if (socialNetworkModel) {
            return new Promise((resolve, reject) => {
                socialNetworkModel.sync('delete', socialNetworkModel, {
                    url: socialNetworkModel.url(),
                    success() {
                        socialNetworkModel.set({status: STATUS_DELETED});
                        resolve(socialNetworkModel.toJSON());
                    },
                    error(model, response) {
                        reject(`${response.statusText}: ${response.responseJSON.message}`);
                    }
                });
            });
        }

        return Promise.resolve();
    }
});

module.exports = UserSocialNetworks;



// WEBPACK FOOTER //
// ./~/bunsen/collections/identity/UserSocialNetworks.es.js